// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:769px){.content__title[data-v-25538066]{max-width:60%}.content__description[data-v-25538066]{max-width:90%}}", ""]);
// Exports
module.exports = exports;
